<template>
    <div id="header">
        <div id="top" class="row">
            <div id="brand" class="base m-span">
                <div class="m_pad">
                    <a class="fill" href="/candidate-statements" aria-label="Logo - Home">
                        <div id="header-logo" class="m-margin-align-c" @click="onLogoClickedHandler">
                            <div class="base">
                                <img title="Los Angeles County RR/CC" alt="Los Angeles County RR/CC" src="@/assets/images/county_seal.png" width="60" height="60"/>
                            </div>
                            <div id="txt" class="base margin-l single">
                                <p>{{ $t("Template.Brand.Location") }}</p>
                                <p><b>{{ $t("Template.Brand.Department") }}</b></p>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div>
                <div id="primary-nav" class="m-d-toggle right">
                    <ul>
                        <li class="primary"><a href="https://www.lavote.net" target="_blank" aria-label="Navigate to LA Vote">LAVote.gov</a></li>
                        <li class="primary"><a href="https://www.lavote.net/about-us/about-us" target="_blank" aria-label="Navigate to About Us">{{ $t('Template.Navigation.AboutUs') }}</a></li>
                        <li class="primary"><a href="https://www.lavote.net/contact-us/contact-us" target="_blank" aria-label="Navigate to Contact Us">{{ $t('Template.Navigation.ContactUs') }}</a></li>
                        <li id="button-language" class="image-nav">
                            <a>
                                <img class="swap" :src="require('@/assets/images/icon_language.png')" alt="Icon - Language" title="Language" width="40" height="40"/>
                                <img class="hide hover" :src="require('@/assets/images/icon_language_hover.png')" alt="Icon - Language" title="Language" width="40" height="40"/><span class="current_language">{{ $t('Template.LanguageName') }}</span>
                            </a>
                        </li>
                    </ul>
                    <LanguageSelectionMenu id="language-selection" @select-language="ASSETS.LanguageSelection.Select($event, this, this.$route)"/>
                </div>
                <div id="m-primary-nav" class="m-toggle row">
                    <div id="m-primary-nav-btn" class="table m-span">
                        <div class="base btn m-margin cursor-pointer" @click="toggle('m-primary-nav-items')">
                            <img :src="require('@/assets/images/m/icon_nav_primary.png')" alt="Icon - Mobile Primary Navigation" title="Mobile Primary Navigation"/>
                        </div>
                        <div id="m-button-language" class="image-nav right"><a aria-label="Language">
                            <img class="swap" :src="require('@/assets/images/icon_language.png')" alt="Icon - Language" title="Language" width="30" height="30">
                            <img class="hide hover" :src="require('@/assets/images/icon_language_hover.png')" alt="Icon - Language" title="Language" width="30" height="30"><span class="current-language">{{ $t('Template.LanguageName') }}</span></a>
                        </div>
                    </div>
                    <div id="m-primary-nav-items" class="hide m-span">
                        <ul>
                            <li><a href="https://www.lavote.net" target="_blank">LAVote.gov</a></li>
                            <li><a href="https://lavote.net/about-us-about-us" target="_blank">{{ $t("Template.Navigation.AboutUs") }}</a></li>
                            <li><a href="https://www.lavote.net/contact-us/contact-us" target="_blank">{{ $t('Template.Navigation.ContactUs') }}</a></li>
                        </ul>
                    </div>
                    <LanguageSelectionMenu id="m-language-selection" @select-language="ASSETS.LanguageSelection.Select($event, this, this.$route)"/>
                </div>
            </div>
        </div>
        <div id="header-details" class="row">
            <div class="m-span">
                <span id="page-title" style="text-transform: none;">{{ $t("Template.Title") }}</span>
            </div>
        </div>
    </div>
    <div id="platform">
        <div id="desktop" class="hide"></div>
        <div id="mobile" class="hide"></div>
    </div>
</template>

<script>
    import LanguageSelectionMenu from '@/components/LanguageSelectionMenu'
    import { ASSETS } from '@/assets/js/assets.js'
    export default {
        name: 'Header',
        data: () => ({
            ASSETS,
            language: localStorage.getItem('language') || 'English'
        }),
        components: { LanguageSelectionMenu },
        methods: {
            toggle(element) {
                element = document.getElementById(element);
                element.style.display = element.style.display === 'none' || element.style.display === '' ? 'block' :
                    'none';
            },
            onLogoClickedHandler() {
                localStorage.clear();
            }
        },
        mounted() {
            ASSETS.Platform.Construct();
            ASSETS.LanguageSelection.Construct();
        }
    }
</script>